/**
 * Trial Banner
 * CCH Care - Version 1.0
 * 
 * Shows at the top of the dashboard for trial/expired accounts.
 * - Trial active: Shows days remaining + upgrade link
 * - Expired: Shows expired warning + activate button
 */

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTrialStatus } from '../../api/auth';
import { COLORS } from '../../config/constants';

export default function TrialBanner() {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    getTrialStatus()
      .then(setStatus)
      .catch(() => {}); // Silently fail — non-trial accounts just won't show banner
  }, []);

  if (!status || status.is_active) return null; // Fully activated — no banner
  if (!status.is_trial && !status.is_expired) return null;

  const isExpired = status.is_expired;
  const days = status.days_remaining;
  const hasPending = status.activation_request?.status === 'pending';

  return (
    <div style={{
      padding: '12px 20px',
      background: isExpired ? COLORS.dangerLight : days <= 3 ? COLORS.warningLight : COLORS.primaryLight,
      borderBottom: `1px solid ${isExpired ? 'rgba(231,76,60,0.2)' : days <= 3 ? 'rgba(230,126,34,0.2)' : 'rgba(27,107,147,0.2)'}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 12,
    }}>
      <div style={{
        fontSize: 14, fontWeight: 600,
        color: isExpired ? COLORS.danger : days <= 3 ? COLORS.warning : COLORS.primary,
      }}>
        {isExpired
          ? '⚠️ Your trial has expired. Your account is in read-only mode.'
          : days === 1
            ? '⏰ Your trial ends today!'
            : `📅 ${days} days remaining on your free trial`
        }
      </div>
      {hasPending ? (
        <div style={{
          fontSize: 13, fontWeight: 600,
          color: COLORS.textMuted, padding: '6px 16px',
          background: 'rgba(0,0,0,0.05)', borderRadius: 6,
        }}>
          ✓ Activation request pending
        </div>
      ) : (
        <button
          onClick={() => navigate('/activate')}
          style={{
            padding: '8px 20px', borderRadius: 8, border: 'none',
            background: isExpired ? COLORS.danger : COLORS.primary,
            color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer',
          }}
        >
          {isExpired ? 'Activate Now' : 'Upgrade'}
        </button>
      )}
    </div>
  );
}
